module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-08.ced31cf1.png";